export default class BackMainLandPackageList {
    warehouseInfoId: number;
    id: number;
    cargoCategory: number;
    long: number;
    wide: number;
    high: number;
    weight: number;
    mainLandInterNationalShipment: string;
    createTime: Date;
    updateTime: Date;
    createUserId: string;
    updateUserId: string;
    isSend: boolean;
    warehouseName: string;
    updateUserName: string;
    createUserName: string;
    packageName: string;
    appointUserId: number;
    AppointUserName: string;
}